import { IChatVoice } from "../components/voices/types";

export const priortizeVoiceId = (voices: IChatVoice[], voiceId: string): IChatVoice[] => {
  if (!voiceId) {
    return voices;
  }
  voices?.sort((voiceA, voiceB) => (voiceA?.id === voiceId ? -1 : voiceB?.id === voiceId ? 1 : 0));
  return voices;
};
